export const FONT_API = 'https://fonts.googleapis.com';
export const REQUEST_COMING_FROM = 'web';
export const FALLBACK_LANGUAGE = 'en';
export const WEBSITE_TITLE_TEMPLATE = (siteName: string) => `%s | ${siteName}`;
export const DEFAULT_PHONE_NUMBER = '1-347-850-2720';
export const PLATFORM_BASE = '/platform';

const all = {
    FONT_API,
    FALLBACK_LANGUAGE,
    REQUEST_COMING_FROM,
    WEBSITE_TITLE_TEMPLATE,
    DEFAULT_PHONE_NUMBER,
};
export default all;
